// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import BusinessDetailsActionTypes from './business-details.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	tabChangeValue: 'Business Details',
	isShowOffCanvas: false,
	isBusinessEdit: false,
	addBusinessDetailsResponse: null,
	addBusinessDetailsResp: [],
	updateBusinessDetailsResponse: null,
	fetchBusinessDetailsResponse: null,
	fetchBusinessDetailsData: [],
	deleteBusinessResponse: null,

	getBusinessListResponse: null,
	getBusinessList: [],

	businessExistCheckResponse: null,
	businessExistCheckArr: [],

	updatIsBusinessApproveResponse: null,

	isBusinessIdStartResponse: null,
};

const businessDetailsReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case BusinessDetailsActionTypes.BUSINESS_SUBMIT_TAB_VALUE_CHANGED:
			return { ...state, tabChangeValue: action.payload };

		case BusinessDetailsActionTypes.BUSINESS_IS_OPEN_OFFCANVAS:
			return { ...state, isShowOffCanvas: action.payload };

		case BusinessDetailsActionTypes.IS_EDIT_BUSINESS_DETAILS:
			return { ...state, isBusinessEdit: action.payload };

		case BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_SUCCESS:
			return {
				...state,
				addBusinessDetailsResponse: action.payload,
				addBusinessDetailsResp: docodeHexResponse(action.payload, 'BusinessDetailsKey'),
			};

		case BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_FAILURE:
			return { ...state, addBusinessDetailsResponse: action.payload };

		case BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_RESPONSE_CHANGED:
			return { ...state, addBusinessDetailsResponse: null };

		case BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_SUCCESS:
			return { ...state, updateBusinessDetailsResponse: action.payload };

		case BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_FAILURE:
			return { ...state, updateBusinessDetailsResponse: action.payload };

		case BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateBusinessDetailsResponse: null };

		case BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_SUCCESS:
			return {
				...state,
				fetchBusinessDetailsResponse: action.payload,
				fetchBusinessDetailsData: docodeHexResponse(
					action.payload,
					'GetBusinessDetailsKey',
				),
				addBusinessDetailsResp: docodeHexResponse(action.payload, 'GetBusinessDetailsKey'),
			};

		case BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_FAILURE:
			return { ...state, fetchBusinessDetailsResponse: action.payload };

		case BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchBusinessDetailsResponse: null,
				fetchBusinessDetailsData: [],
				// addBusinessDetailsResp: [],
			};

		case BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_SUCCESS:
			return { ...state, deleteBusinessResponse: action.payload };

		case BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_FAILURE:
			return { ...state, deleteBusinessResponse: action.payload };

		case BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteBusinessResponse: null };

		case BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_SUCCESS:
			return {
				...state,
				getBusinessListResponse: action.payload,
				getBusinessList: docodeHexResponse(action.payload, 'GetBusinessListKey'),
			};

		case BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_FAILURE:
			return { ...state, getBusinessListResponse: action.payload };

		case BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_RESPONSE_CHANGED:
			return { ...state, getBusinessListResponse: null };

		/********** BUSINESS DETAILS EXIST CHECK START **********/
		case BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_SUCCESS:
			return {
				...state,
				businessExistCheckResponse: action.payload,
			};

		case BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_FAILURE:
			return {
				...state,
				businessExistCheckResponse: action.payload,
			};

		case BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_RESPONSE_CHANGED:
			return { ...state, businessExistCheckResponse: null };
		/********** BUSINESS DETAILS EXIST CHECK END **********/

		/*************** START BUSINESS APPROVE DETAILS ******************/
		case BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_SUCCESS:
			return {
				...state,
				updatIsBusinessApproveResponse: action.payload,
			};

		case BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_FAILURE:
			return {
				...state,
				updatIsBusinessApproveResponse: action.payload,
			};

		case BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_RESPONSE_CHANGED:
			return { ...state, updatIsBusinessApproveResponse: null };
		/*************** END BUSINESS APPROVE DETAILS ******************/
		case BusinessDetailsActionTypes.IS_BUSINESS_ID_START:
			return {
				...state,
				isBusinessIdStartResponse: action.payload,
			};

		default:
			return state;
	}
};
export default businessDetailsReducer;
